module.exports = __webpack_public_path__ + "static/media/tdsDrivingContent.5053797a.jpg";